import React from 'react'
import "../Product/Intro.css"; 
import { useLanguage } from "../LanguageContext";

const AboutOurPartners = () => {
    const { language } = useLanguage();
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading"><span>OUR PARTNERS</span></h2>
        <p className="description">
          {" "}
          {language === "en" ? (
            <>
              Our Technology Partners
              <br />
              <strong>
                Stronger Together — Empowering Clients Through Strategic
                Alliances
              </strong>
              <br />
              At Proscope, we believe that delivering impactful IT solutions
              starts with building the right partnerships. We work closely with
              world-class technology vendors, solution providers, and emerging
              innovators to ensure that our clients benefit from proven,
              trusted, and future-ready technologies.
              <br />
              <br />
            </>
          ) : (
            <>
              พาร์ตเนอร์เทคโนโลยีของเรา
              <br />
              <strong>
                {" "}
                เติบโตไปด้วยกัน — เสริมพลังให้ลูกค้าผ่านความร่วมมือเชิงกลยุทธ์
              </strong>
              <br />
              ที่ Proscope เราเชื่อว่าการส่งมอบโซลูชันไอทีที่มีประสิทธิภาพ
              เริ่มต้นจากการมีพันธมิตรที่แข็งแกร่ง
              เราจึงทำงานร่วมกับผู้ให้บริการเทคโนโลยีระดับโลก ผู้พัฒนาโซลูชัน
              และนวัตกรรมใหม่ ๆ
              เพื่อให้ลูกค้าของเราได้รับประโยชน์จากเทคโนโลยีที่เชื่อถือได้และพร้อมสำหรับอนาคต
              <br />
              <br />
            </>
          )}
        </p>

        <p className="description">
          {" "}
          {language === "en" ? (
            <>
              Our partner ecosystem enables us to:
              <br />
              &nbsp;&bull; Access cutting-edge products and platforms — from
              servers and storage to cloud services and cybersecurity tools
              <br />
              &nbsp;&bull; Co-develop customized solutions that fit real
              business needs
              <br />
              &nbsp;&bull; Deliver fast, reliable support through direct vendor
              channels
              <br />
              &nbsp;&bull; Stay ahead of technology trends with ongoing training
              and certification
              <br />
              &nbsp;&bull; Ensure long-term value through authorized service
              programs and extended warranties
              <br />
              <br />
              Whether it’s infrastructure, software, endpoint devices, or hybrid
              cloud environments — our partner alliances help us deliver the
              right solution with the right support, every time.
              <br />
              <br />
              We don’t just resell products. We co-create success with our
              partners — so our customers always get the best.
            </>
          ) : (
            <>
              ความร่วมมือกับพาร์ตเนอร์ทำให้เรา:
              <br />
              &nbsp;&bull; เข้าถึงผลิตภัณฑ์และแพลตฟอร์มล้ำสมัย —
              ตั้งแต่ระบบเซิร์ฟเวอร์ สตอเรจ คลาวด์
              ไปจนถึงเครื่องมือรักษาความปลอดภัยไซเบอร์
              <br />
              &nbsp;&bull;
              ร่วมพัฒนาโซลูชันที่ตอบโจทย์ความต้องการของลูกค้าในแต่ละอุตสาหกรรม
              <br />
              &nbsp;&bull;
              ให้การสนับสนุนได้รวดเร็วและมีประสิทธิภาพผ่านช่องทางของผู้ผลิตโดยตรง
              <br />
              &nbsp;&bull; พัฒนาทักษะทีมงานอย่างต่อเนื่อง
              ผ่านการอบรมและรับรองจากผู้ผลิต
              <br />
              &nbsp;&bull;  มอบความคุ้มค่าในระยะยาว
              ด้วยบริการหลังการขายที่ได้รับอนุญาตและการรับประกันแบบขยาย
              <br />
              <br />
              ไม่ว่าคุณจะมองหาโครงสร้างพื้นฐาน ซอฟต์แวร์ อุปกรณ์ปลายทาง
              หรือระบบไฮบริดคลาวด์ —
              ความร่วมมือของเรากับพันธมิตรจะช่วยให้คุณได้รับโซลูชันที่เหมาะสม
              พร้อมบริการที่เชื่อมั่นได้ในทุกขั้นตอน
              <br />
              <br />
              เราไม่ได้เป็นแค่ตัวแทนจำหน่าย
              เราร่วมมือกับพาร์ตเนอร์เพื่อสร้างความสำเร็จให้กับลูกค้า —
              อย่างแท้จริง
            </>
          )}
        </p>

        <div className="horizontal-text-container">
          <p>About Us</p>
          <p>/</p>
          <p>Our Products</p>
        </div>
      </div>
    </div>
  );
}

export default AboutOurPartners